module.exports = __webpack_public_path__ + "img/candidates-active.884baa47.svg";